import Viewer from "./router"; 


import './App.css';
//import { useEffect, useState } from "react";
import {Box} from '@mui/system'

function App() {
  


  return (
    <Box>
       <Viewer/>
    </Box>
   )
}

export default App;
